import React from 'react';

import {MediumText, RegularText, SemiBoldText} from 'shared/components/text';
import styled from 'styled-components';
import SizePrice from './size-price';

import {SizeProps} from 'modules/products/types';
import Column from 'shared/components/column';
import Row from 'shared/components/row';
import useSize from 'modules/products/util/use-size';

interface Props {
  sizes: SizeProps[];
  productIndex?: number;
}

const Sizes: React.FC<Props> = ({sizes, productIndex}) => {
  const {size, setSize} = useSize();

  return (
    <Container>
      <Section>
        <SemiBoldText size="small">Tamanho</SemiBoldText>
        <Row justifyContent="space-between">
          <RegularText size="small">{size ? 1 : 0} de 1</RegularText>
          <Mandatory>
            <SemiBoldText size={'extra-small'} color="white">
              OBRIGATÓRIO
            </SemiBoldText>
          </Mandatory>
        </Row>
      </Section>
      {sizes.map((someSize) => (
        <Size key={someSize.id} onClick={() => setSize(someSize)}>
          <Row justifyContent="space-between">
            <Column>
              <MediumText size="small">{someSize.name}</MediumText>
              <SizePrice {...{...someSize, productIndex}} />
            </Column>
            <Radius
              active={size?.name === someSize.name}
              onClick={() => setSize(someSize)}
            />
          </Row>
        </Size>
      ))}
    </Container>
  );
};

export default Sizes;

interface RadiusProps {
  active?: boolean;
}

const Container = styled.div``;

const Section = styled.div`
  padding: 15px;
  background-color: #f2f2f2;
`;

const Mandatory = styled.div`
  border-radius: 3px;
  padding: 5px;
  background-color: black;
`;

const Size = styled.button`
  display: flex;
  padding: 15px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.4);
  background-color: white;

  border: none;
  cursor: pointer;
`;

const Radius = styled.button<RadiusProps>`
  width: 25px;
  height: 25px;
  border-radius: 13px;

  background-color: ${(props) => (props.active ? 'white' : '#ebebeb')};
  border: ${(props) =>
    props.active ? `6px solid ${props.theme.colors.primary}` : '0'};

  cursor: pointer;
  padding: 0;
`;
